/**
 * Error thrown when a JssCanActivate guard returns a redirect value.
 * The redirect value will be used to redirect the user to a different route.
 */
export class JssCanActivateRedirectError extends Error {
    message;
    redirectValue;
    constructor(message, redirectValue) {
        super(message);
        this.message = message;
        this.redirectValue = redirectValue;
        this.name = 'JssCanActivateRedirectError';
    }
}
